var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 20.0625C6.41667 19.2708 6.07292 18.4583 5.84375 17.625C5.61458 16.7917 5.5 15.9375 5.5 15.0625C5.5 12.2708 6.46875 9.89583 8.40625 7.9375C10.3438 5.97917 12.7083 5 15.5 5H15.7188L13.7188 3L15.4688 1.25L20.4688 6.25L15.4688 11.25L13.7188 9.5L15.7188 7.5H15.5C13.4167 7.5 11.6458 8.23438 10.1875 9.70312C8.72917 11.1719 8 12.9583 8 15.0625C8 15.6042 8.0625 16.1354 8.1875 16.6562C8.3125 17.1771 8.5 17.6875 8.75 18.1875L6.875 20.0625ZM15.5312 28.75L10.5312 23.75L15.5312 18.75L17.2812 20.5L15.2812 22.5H15.5C17.5833 22.5 19.3542 21.7656 20.8125 20.2969C22.2708 18.8281 23 17.0417 23 14.9375C23 14.3958 22.9375 13.8646 22.8125 13.3438C22.6875 12.8229 22.5 12.3125 22.25 11.8125L24.125 9.9375C24.5833 10.7292 24.9271 11.5417 25.1562 12.375C25.3854 13.2083 25.5 14.0625 25.5 14.9375C25.5 17.7292 24.5312 20.1042 22.5938 22.0625C20.6562 24.0208 18.2917 25 15.5 25H15.2812L17.2812 27L15.5312 28.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuffer);
export default __webpack_public_path__ + "static/media/buffer.9920ff8874a8af09d50cd86994a66cc6.svg";
export { ForwardRef as ReactComponent };